import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'
import '@/assets/css/theme/index.css'
import request from "@/utils/request";

Vue.config.productionTip = false

Vue.prototype.$request = request
Vue.prototype.$baseUrl = process.env.VUE_APP_BASEURL
// 文件下载鉴权（/files 纳入登录校验后）：图片地址自动追加 token 参数
Vue.prototype.$fileUrl = function (url) {
  if (!url) return url
  if (url.indexOf('/files/') === -1) return url
  const user = JSON.parse(localStorage.getItem('xm-user') || '{}')
  if (!user.token) return url
  return url + (url.indexOf('?') > -1 ? '&' : '?') + 'token=' + encodeURIComponent(user.token)
}

Vue.use(ElementUI, {size: "small"})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
